import script from "./RowBox.vue?vue&type=script&setup=true&lang=js"
export * from "./RowBox.vue?vue&type=script&setup=true&lang=js"

import "./RowBox.vue?vue&type=style&index=0&id=ef60ec2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef60ec2e"]])

export default __exports__